<template>
  <div>
    <div
      tabindex="0"
      class="tw-cursor-pointer tw-block tw-border tw-border-gray dark:tw-border-dm-gray tw-rounded-3xl tw-p-6 tw-transition hover:tw-shadow"
      @click="$emit('open-detail')"
    >
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-w-full">
          <div class="tw-flex tw-items-start tw-justify-between">
            <div class="tw-flex tw-items-center">
              <icon-star
                v-if="permit.is_main"
                class="tw-w-4 tw-h-4 tw-text-primary dark:tw-text-dm-primary tw-mr-1"
              />
              <span class="tw-text-[12px] tw-leading-[14px] tw-text-gray-dark dark:tw-text-dm-gray-dark">
                {{ permit.reference_number }}
              </span>
            </div>
            <div v-if="permit.permit_document_missing_count">
              <i-badge
                type="primary"
                size="medium"
                is-circle
              >
                {{ permit.permit_document_missing_count }}
              </i-badge>
            </div>
          </div>

          <h3 class="tw-leading-6 tw-tracking-wide">
            {{ permit.permit_type_name }}
          </h3>

          <div
            class="tw-leading-5 tw-tracking-normal tw-text-gray-dark dark:tw-text-dm-gray-dark tw-mt-5"
          >
            {{ permit.current_status_type_name }}
          </div>
        </div>
      </div>
      <i-step-progress
        :steps="permit.status_count"
        :active-step="permit.current_status_human_order"
        class="tw-mt-2.5"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PermitBoxInProgress',
  props: {
    permit: {
      type: Object,
      required: true,
    },
  },
};
</script>
